// extracted by mini-css-extract-plugin
module.exports = {"inputs":"CreatePattern_inputs__3glUd"};